// src/components/Auth/SocialSignInButtons.tsx

import { signInWithRedirect } from 'aws-amplify/auth';
import type React from 'react';
import type { JSX } from 'react';

import { SignInWIthGoogleSvg, SignInWithMicrosoftSvg } from 'src/assets/icons/SiginInPageIcons';
import { AuthCardSso, Button } from 'src/components/DS';

const getAuthProviderDetails: {
  [key: string]: {
    buttonLabel: string;
    buttonIcon: JSX.Element;
  };
} = {
  microsoft_ad: {
    buttonLabel: 'Continue with Microsoft',
    buttonIcon: <SignInWithMicrosoftSvg />,
  },
  google: {
    buttonLabel: 'Continue with Google',
    buttonIcon: <SignInWIthGoogleSvg />,
  },
};

type Provider = {
  enabled: boolean;
  provider_name: string;
  provider: string;
};

type SocialSignInButtonsProps = {
  providers: Provider[];
};

const SocialSignInButtons: React.FC<SocialSignInButtonsProps> = ({ providers }) => {
  const enabledProviders = providers?.filter((p) => p?.enabled);

  if (!enabledProviders?.length) return null;

  const handleFederatedSignIn = (providerType: string, providerName: string) => {
    if (providerType === 'microsoft_ad') {
      signInWithRedirect({
        provider: { custom: providerName },
      });
    } else if (providerType === 'google') {
      signInWithRedirect({
        provider: 'Google',
      });
    }
  };

  return (
    <AuthCardSso>
      {enabledProviders.map(({ provider_name, provider: providerType }) => {
        const authProvider = getAuthProviderDetails?.[providerType] || {};
        return (
          <Button
            key={providerType}
            type="button"
            variant="secondary"
            block
            leftIcon={authProvider?.buttonIcon}
            onClick={() => handleFederatedSignIn(providerType, provider_name)}
          >
            {authProvider?.buttonLabel}
          </Button>
        );
      })}
    </AuthCardSso>
  );
};

export default SocialSignInButtons;
